"use strict";
var body = document.querySelector("body");
var tableHead = document.querySelector("thead");
var tableBody = document.querySelector("tbody");
// #region sorting table
var columnsAll = tableHead.querySelectorAll("th");
var sortDirection = 1;
var sortedColumnIndex = -1;
columnsAll.forEach(function(th) {
    th.addEventListener("click", function(e) {
        var clickedIndex = Array.from(columnsAll).indexOf(e.target);
        if (sortedColumnIndex === clickedIndex) sortDirection = -sortDirection;
        else {
            sortDirection = 1;
            sortedColumnIndex = clickedIndex;
        }
        var rowsArray = Array.from(tableBody.querySelectorAll("tr"));
        rowsArray.sort(function(rowA, rowB) {
            var cellA = rowA.querySelectorAll("td")[sortedColumnIndex].textContent;
            var cellB = rowB.querySelectorAll("td")[sortedColumnIndex].textContent;
            var clearNumA = cellA.replace("$", "").replaceAll(",", "");
            var clearNumB = cellB.replace("$", "").replaceAll(",", "");
            var aNum = Number(clearNumA);
            var bNum = Number(clearNumB);
            if (!isNaN(aNum) && !isNaN(bNum)) return (aNum - bNum) * sortDirection;
            return cellA.localeCompare(cellB) * sortDirection;
        });
        rowsArray.forEach(function(row) {
            return tableBody.append(row);
        });
    });
});
// #endregion
// #region active class
tableBody.addEventListener("click", function(e) {
    tableBody.querySelectorAll("tr").forEach(function(row) {
        return row.classList.remove("active");
    });
    var clickedRow = e.target.closest("tr");
    if (clickedRow) clickedRow.classList.add("active");
});
// #endregion
// #region form new employee
var form = document.createElement("form");
form.classList.add("new-employee-form");
function createField(data) {
    var newField = document.createElement("label");
    newField.textContent = data.label;
    var input = document.createElement("input");
    input.setAttribute("type", data.type);
    input.setAttribute("name", data.name);
    input.setAttribute("data-qa", data.qa);
    newField.append(input);
    return newField;
}
var nameField = createField({
    label: "Name:",
    type: "text",
    name: "name",
    qa: "name"
});
var positionField = createField({
    label: "Position:",
    type: "text",
    name: "position",
    qa: "position"
});
var ageField = createField({
    label: "Age:",
    type: "number",
    name: "age",
    qa: "age"
});
var salaryField = createField({
    label: "Salary:",
    type: "number",
    name: "salary",
    qa: "salary"
});
form.append(nameField);
form.append(positionField);
form.append(ageField);
form.append(salaryField);
body.append(form);
// #endregion
// #region selectOption
var labelForSelect = document.createElement("label");
var select = document.createElement("select");
select.setAttribute("name", "office");
select.setAttribute("data-qa", "office");
function createOption(city) {
    var option = document.createElement("option");
    option.value = city;
    option.textContent = city;
    select.append(option);
}
createOption("Tokyo");
createOption("Singapore");
createOption("New York");
createOption("Edinburgh");
createOption("San Francisco");
createOption("London");
labelForSelect.textContent = "Office: ";
labelForSelect.append(select);
form.append(labelForSelect);
// #endregion
// #region button and notificattion
var button = document.createElement("button");
button.textContent = "Save to table";
button.setAttribute("type", "submit");
form.append(button);
// #region notification
var notification = document.createElement("div");
body.append(notification);
notification.classList.add("notification", "title");
notification.setAttribute("data-qa", "notification");
form.addEventListener("submit", function(e) {
    e.preventDefault();
    notification.textContent = "";
    notification.classList.remove("error", "success", "warning");
    var formData = new FormData(form);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            if (value === "") {
                notification.textContent = "Please, fill in all fields. <3";
                notification.classList.add("error");
                return;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (formData.get("name").length < 4) {
        notification.textContent = "The name must be at least 4 letters long.";
        notification.classList.add("error");
        return;
    }
    var age = Number(formData.get("age"));
    if (age < 18 || age > 90) {
        notification.textContent = // eslint-disable-next-line max-len
        "Young people under the age of 18 cannot be included in the table, nor can people over the age of 90.";
        notification.classList.add("error");
        return;
    }
    var salary = Number(formData.get("salary"));
    if (salary <= 0) {
        notification.textContent = "People who do not have a salary cannot occupy a place in the table.";
        notification.classList.add("error");
        return;
    }
    // #endregion
    // #region add new employee
    var newEployee = document.createElement("tr");
    var keys = [
        "name",
        "position",
        "office",
        "age",
        "salary"
    ];
    for(var i = 0; i < keys.length; i++){
        var newData = document.createElement("td");
        if (keys[i] === "salary") {
            // eslint-disable-next-line no-shadow
            var salary1 = Number(formData.get("salary"));
            newData.textContent = "$".concat(salary1.toLocaleString("en-US"));
        } else newData.textContent = formData.get(keys[i]);
        newEployee.append(newData);
    }
    tableBody.append(newEployee);
    // #endregion
    notification.classList.add("success");
    notification.textContent = "Employee added successfully.";
});
// #endregion
// #region dbclick function
var editingCell = null;
tableBody.addEventListener("dblclick", function(e) {
    var save = function save() {
        var newValue = newData.value.trim();
        clickCell.textContent = newValue === "" ? oldText : newValue;
        editingCell = null;
    };
    var clickCell = e.target.closest("td");
    if (!clickCell) return;
    if (editingCell) return;
    editingCell = clickCell;
    var oldText = clickCell.textContent;
    clickCell.textContent = "";
    var newData = document.createElement("input");
    newData.classList.add("cell-input");
    newData.setAttribute("type", "text");
    newData.setAttribute("value", oldText);
    clickCell.append(newData);
    newData.focus();
    newData.addEventListener("blur", save);
    newData.addEventListener("keydown", function(evet) {
        if (evet.key === "Enter") newData.blur();
    });
}); // #endregion

//# sourceMappingURL=index.935e6214.js.map
